import {Component} from 'react';
import {translateAPIResponse} from '../../utils/form';

export default class BaseForm extends Component {
    showAlert() {
        return true;
    }
    submit(values) {
        const {onSuccessSubmit, submit} = this.props;
        const hadId = !values.id;
        return submit(values).then(translateAPIResponse).then((result) => {
            if (this.showAlert()) {
                alert('Saved');
            }
            if (onSuccessSubmit) {
                onSuccessSubmit(hadId, result.payload);
            }
        });
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/js/components/form/base-form.js